export const INITIAL_LOAD_TIMEOUT_MS = 20_000;

// A race also bounds operations waiting for an SDK lock, before fetch starts.
// The signal cancels active requests; late results cannot settle this promise.
export async function withRequestDeadline<T>(
  operation: (signal: AbortSignal) => Promise<T>,
  parentSignal?: AbortSignal,
  timeoutMs = INITIAL_LOAD_TIMEOUT_MS,
): Promise<T> {
  const controller = new AbortController();
  const abort = () => controller.abort(parentSignal?.reason);
  let onAbort: () => void = () => {};
  const cancelled = new Promise<never>((_, reject) => {
    onAbort = () => reject(controller.signal.reason);
    controller.signal.addEventListener('abort', onAbort, { once: true });
  });
  parentSignal?.addEventListener('abort', abort, { once: true });
  if (parentSignal?.aborted) abort();
  const timer = setTimeout(() => controller.abort(new DOMException('O carregamento demorou mais que o esperado.', 'TimeoutError')), timeoutMs);
  try {
    let request: Promise<T>;
    try {
      controller.signal.throwIfAborted();
      request = Promise.resolve(operation(controller.signal));
    } catch (error) {
      request = Promise.reject(error);
    }
    return await Promise.race([cancelled, request]);
  } finally {
    clearTimeout(timer);
    parentSignal?.removeEventListener('abort', abort);
    controller.signal.removeEventListener('abort', onAbort);
  }
}
